// Marketplace Mock Data with Commission Model from Margins
// Commission Structure:
// - Marketplace (Bonndle): 5% on all sales
// - Referral Commission: 10% (only when referral merchant is DIFFERENT from seller)
// - Seller Revenue: 85% (with referral) or 95% (no referral/same merchant)

export const COMMISSION_RATES = {
  MARKETPLACE: 0.05,  // 5% to Bonndle marketplace
  REFERRAL: 0.10,     // 10% to referral merchant (only if different from seller)
  SELLER_WITH_REFERRAL: 0.85,  // 85% to selling merchant when there's a referral
  SELLER_NO_REFERRAL: 0.95,    // 95% to selling merchant when no referral
};

// Categories
export const CATEGORIES = [
  { id: 'fashion', name: 'Fashion', icon: 'Shirt', color: 'bg-pink-500' },
  { id: 'healthcare', name: 'Healthcare', icon: 'Heart', color: 'bg-red-500' },
  { id: 'technology', name: 'Technology', icon: 'Smartphone', color: 'bg-blue-500' },
  { id: 'baby', name: 'Baby & Kids', icon: 'Baby', color: 'bg-yellow-500' },
  { id: 'education', name: 'Education', icon: 'BookOpen', color: 'bg-green-500' },
];

// Merchants
export const MERCHANTS = [
  // Fashion Merchants
  {
    id: 'merchant-fashion-1',
    name: 'Urban Threads',
    slug: 'urban-threads',
    category: 'fashion',
    logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=400&fit=crop',
    description: 'Contemporary fashion for the modern lifestyle',
    rating: 4.8,
    reviewCount: 2340,
    totalSales: 15680,
    commissionsEarned: 4520.50,
    commissionsPaid: 2890.25,
    verified: true,
  },
  {
    id: 'merchant-fashion-2',
    name: 'Elegance Boutique',
    slug: 'elegance-boutique',
    category: 'fashion',
    logo: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=800&h=400&fit=crop',
    description: 'Luxury fashion and accessories',
    rating: 4.9,
    reviewCount: 1890,
    totalSales: 28900,
    commissionsEarned: 6780.00,
    commissionsPaid: 4320.75,
    verified: true,
  },
  {
    id: 'merchant-fashion-3',
    name: 'Street Style Co',
    slug: 'street-style-co',
    category: 'fashion',
    logo: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800&h=400&fit=crop',
    description: 'Streetwear and urban fashion',
    rating: 4.6,
    reviewCount: 3120,
    totalSales: 12450,
    commissionsEarned: 3200.00,
    commissionsPaid: 1890.50,
    verified: true,
  },

  // Healthcare Merchants
  {
    id: 'merchant-health-1',
    name: 'VitaLife Wellness',
    slug: 'vitalife-wellness',
    category: 'healthcare',
    logo: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=400&fit=crop',
    description: 'Premium vitamins and supplements',
    rating: 4.7,
    reviewCount: 4560,
    totalSales: 34200,
    commissionsEarned: 8900.00,
    commissionsPaid: 5120.25,
    verified: true,
  },
  {
    id: 'merchant-health-2',
    name: 'MedCare Plus',
    slug: 'medcare-plus',
    category: 'healthcare',
    logo: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=400&fit=crop',
    description: 'Medical supplies and health equipment',
    rating: 4.8,
    reviewCount: 2890,
    totalSales: 45600,
    commissionsEarned: 12300.00,
    commissionsPaid: 6840.50,
    verified: true,
  },
  {
    id: 'merchant-health-3',
    name: 'Natural Remedies',
    slug: 'natural-remedies',
    category: 'healthcare',
    logo: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=400&fit=crop',
    description: 'Organic and natural health products',
    rating: 4.5,
    reviewCount: 1670,
    totalSales: 18900,
    commissionsEarned: 4560.00,
    commissionsPaid: 2830.75,
    verified: false,
  },

  // Technology Merchants
  {
    id: 'merchant-tech-1',
    name: 'TechGear Pro',
    slug: 'techgear-pro',
    category: 'technology',
    logo: 'https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=400&fit=crop',
    description: 'Latest gadgets and tech accessories',
    rating: 4.9,
    reviewCount: 5670,
    totalSales: 89500,
    commissionsEarned: 23400.00,
    commissionsPaid: 13420.50,
    verified: true,
  },
  {
    id: 'merchant-tech-2',
    name: 'SmartHome Hub',
    slug: 'smarthome-hub',
    category: 'technology',
    logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1558002038-1055907df827?w=800&h=400&fit=crop',
    description: 'Smart home devices and automation',
    rating: 4.7,
    reviewCount: 3450,
    totalSales: 56700,
    commissionsEarned: 14500.00,
    commissionsPaid: 8500.25,
    verified: true,
  },
  {
    id: 'merchant-tech-3',
    name: 'AudioVision',
    slug: 'audiovision',
    category: 'technology',
    logo: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=800&h=400&fit=crop',
    description: 'Premium audio and video equipment',
    rating: 4.8,
    reviewCount: 4120,
    totalSales: 72300,
    commissionsEarned: 18900.00,
    commissionsPaid: 10850.75,
    verified: true,
  },

  // Baby & Kids Merchants
  {
    id: 'merchant-baby-1',
    name: 'Little Wonders',
    slug: 'little-wonders',
    category: 'baby',
    logo: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1522771930-78848d9293e8?w=800&h=400&fit=crop',
    description: 'Everything for your little ones',
    rating: 4.9,
    reviewCount: 6780,
    totalSales: 67800,
    commissionsEarned: 17800.00,
    commissionsPaid: 10170.00,
    verified: true,
  },
  {
    id: 'merchant-baby-2',
    name: 'BabyEssentials',
    slug: 'baby-essentials',
    category: 'baby',
    logo: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800&h=400&fit=crop',
    description: 'Quality baby products at great prices',
    rating: 4.6,
    reviewCount: 4230,
    totalSales: 45600,
    commissionsEarned: 11200.00,
    commissionsPaid: 6840.00,
    verified: true,
  },
  {
    id: 'merchant-baby-3',
    name: 'Kids Paradise',
    slug: 'kids-paradise',
    category: 'baby',
    logo: 'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=800&h=400&fit=crop',
    description: 'Toys and games for children of all ages',
    rating: 4.7,
    reviewCount: 5670,
    totalSales: 54300,
    commissionsEarned: 13600.00,
    commissionsPaid: 8145.00,
    verified: true,
  },

  // Education Merchants
  {
    id: 'merchant-edu-1',
    name: 'LearnSmart',
    slug: 'learnsmart',
    category: 'education',
    logo: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800&h=400&fit=crop',
    description: 'Educational materials and courses',
    rating: 4.8,
    reviewCount: 3450,
    totalSales: 38900,
    commissionsEarned: 9800.00,
    commissionsPaid: 5835.00,
    verified: true,
  },
  {
    id: 'merchant-edu-2',
    name: 'BookHaven',
    slug: 'bookhaven',
    category: 'education',
    logo: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&h=400&fit=crop',
    description: 'Books for every reader',
    rating: 4.9,
    reviewCount: 7890,
    totalSales: 92300,
    commissionsEarned: 23800.00,
    commissionsPaid: 13845.00,
    verified: true,
  },
  {
    id: 'merchant-edu-3',
    name: 'SchoolSupply Pro',
    slug: 'schoolsupply-pro',
    category: 'education',
    logo: 'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?w=100&h=100&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=400&fit=crop',
    description: 'School and office supplies',
    rating: 4.5,
    reviewCount: 2340,
    totalSales: 28700,
    commissionsEarned: 7200.00,
    commissionsPaid: 4305.00,
    verified: false,
  },
];

// Products
export const PRODUCTS = [
  // Fashion Products - Urban Threads
  {
    id: 'prod-f1-1',
    merchantId: 'merchant-fashion-1',
    name: 'Classic Cotton T-Shirt',
    description: 'Premium cotton t-shirt with a modern fit. Available in multiple colors.',
    price: 29.99,
    originalPrice: 39.99,
    discount: 25,
    category: 'fashion',
    tags: ['clothing', 't-shirt', 'casual', 'cotton'],
    images: [
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop',
      'https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 234,
    stock: 150,
    sales: 890,
    featured: true,
  },
  {
    id: 'prod-f1-2',
    merchantId: 'merchant-fashion-1',
    name: 'Slim Fit Denim Jeans',
    description: 'Modern slim fit jeans with stretch comfort technology.',
    price: 79.99,
    originalPrice: 99.99,
    discount: 20,
    category: 'fashion',
    tags: ['clothing', 'jeans', 'denim', 'casual'],
    images: [
      'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 567,
    stock: 80,
    sales: 1245,
    featured: true,
  },
  {
    id: 'prod-f1-3',
    merchantId: 'merchant-fashion-1',
    name: 'Casual Hoodie',
    description: 'Soft fleece hoodie perfect for everyday wear.',
    price: 59.99,
    originalPrice: 74.99,
    discount: 20,
    category: 'fashion',
    tags: ['clothing', 'hoodie', 'casual', 'winter'],
    images: [
      'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=400&fit=crop',
    ],
    rating: 4.6,
    reviewCount: 189,
    stock: 65,
    sales: 456,
    featured: false,
  },

  // Fashion Products - Elegance Boutique
  {
    id: 'prod-f2-1',
    merchantId: 'merchant-fashion-2',
    name: 'Silk Evening Dress',
    description: 'Elegant silk dress perfect for special occasions.',
    price: 199.99,
    originalPrice: 249.99,
    discount: 20,
    category: 'fashion',
    tags: ['clothing', 'dress', 'formal', 'silk'],
    images: [
      'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=400&fit=crop',
    ],
    rating: 4.9,
    reviewCount: 156,
    stock: 25,
    sales: 234,
    featured: true,
  },
  {
    id: 'prod-f2-2',
    merchantId: 'merchant-fashion-2',
    name: 'Designer Leather Handbag',
    description: 'Handcrafted leather handbag with premium finish.',
    price: 149.99,
    originalPrice: 189.99,
    discount: 21,
    category: 'fashion',
    tags: ['accessories', 'handbag', 'leather', 'luxury'],
    images: [
      'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 298,
    stock: 40,
    sales: 567,
    featured: true,
  },

  // Fashion Products - Street Style Co
  {
    id: 'prod-f3-1',
    merchantId: 'merchant-fashion-3',
    name: 'Urban Sneakers',
    description: 'Trendy street-style sneakers with comfort sole.',
    price: 89.99,
    originalPrice: 119.99,
    discount: 25,
    category: 'fashion',
    tags: ['shoes', 'sneakers', 'streetwear', 'casual'],
    images: [
      'https://images.unsplash.com/photo-1552346154-21d32810aba3?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 445,
    stock: 120,
    sales: 890,
    featured: true,
  },
  {
    id: 'prod-f3-2',
    merchantId: 'merchant-fashion-3',
    name: 'Graphic Print Cap',
    description: 'Adjustable cap with unique graphic prints.',
    price: 24.99,
    originalPrice: 34.99,
    discount: 29,
    category: 'fashion',
    tags: ['accessories', 'cap', 'streetwear'],
    images: [
      'https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&h=400&fit=crop',
    ],
    rating: 4.5,
    reviewCount: 178,
    stock: 200,
    sales: 345,
    featured: false,
  },

  // Healthcare Products - VitaLife Wellness
  {
    id: 'prod-h1-1',
    merchantId: 'merchant-health-1',
    name: 'Multivitamin Complex',
    description: 'Complete daily multivitamin with 25 essential nutrients.',
    price: 34.99,
    originalPrice: 44.99,
    discount: 22,
    category: 'healthcare',
    tags: ['vitamins', 'supplements', 'health', 'wellness'],
    images: [
      'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 789,
    stock: 300,
    sales: 2340,
    featured: true,
  },
  {
    id: 'prod-h1-2',
    merchantId: 'merchant-health-1',
    name: 'Omega-3 Fish Oil',
    description: 'Premium fish oil capsules for heart and brain health.',
    price: 29.99,
    originalPrice: 39.99,
    discount: 25,
    category: 'healthcare',
    tags: ['supplements', 'omega-3', 'heart-health'],
    images: [
      'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 567,
    stock: 250,
    sales: 1890,
    featured: true,
  },
  {
    id: 'prod-h1-3',
    merchantId: 'merchant-health-1',
    name: 'Protein Powder',
    description: 'Whey protein powder for muscle recovery and growth.',
    price: 49.99,
    originalPrice: 64.99,
    discount: 23,
    category: 'healthcare',
    tags: ['protein', 'fitness', 'supplements'],
    images: [
      'https://images.unsplash.com/photo-1593095948071-474c5cc2989d?w=400&h=400&fit=crop',
    ],
    rating: 4.6,
    reviewCount: 423,
    stock: 180,
    sales: 1234,
    featured: false,
  },

  // Healthcare Products - MedCare Plus
  {
    id: 'prod-h2-1',
    merchantId: 'merchant-health-2',
    name: 'Digital Blood Pressure Monitor',
    description: 'Accurate home blood pressure monitoring device.',
    price: 59.99,
    originalPrice: 79.99,
    discount: 25,
    category: 'healthcare',
    tags: ['medical-device', 'blood-pressure', 'health-monitoring'],
    images: [
      'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=400&fit=crop',
    ],
    rating: 4.9,
    reviewCount: 345,
    stock: 100,
    sales: 678,
    featured: true,
  },
  {
    id: 'prod-h2-2',
    merchantId: 'merchant-health-2',
    name: 'First Aid Kit Premium',
    description: 'Complete first aid kit with 150+ medical supplies.',
    price: 44.99,
    originalPrice: 59.99,
    discount: 25,
    category: 'healthcare',
    tags: ['first-aid', 'medical-supplies', 'safety'],
    images: [
      'https://images.unsplash.com/photo-1603398938378-e54eab446dde?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 234,
    stock: 150,
    sales: 456,
    featured: false,
  },

  // Healthcare Products - Natural Remedies
  {
    id: 'prod-h3-1',
    merchantId: 'merchant-health-3',
    name: 'Organic Herbal Tea Set',
    description: 'Collection of 6 organic herbal teas for wellness.',
    price: 24.99,
    originalPrice: 34.99,
    discount: 29,
    category: 'healthcare',
    tags: ['organic', 'tea', 'natural', 'wellness'],
    images: [
      'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=400&h=400&fit=crop',
    ],
    rating: 4.6,
    reviewCount: 189,
    stock: 200,
    sales: 567,
    featured: true,
  },

  // Technology Products - TechGear Pro
  {
    id: 'prod-t1-1',
    merchantId: 'merchant-tech-1',
    name: 'Wireless Earbuds Pro',
    description: 'Premium wireless earbuds with active noise cancellation.',
    price: 149.99,
    originalPrice: 199.99,
    discount: 25,
    category: 'technology',
    tags: ['audio', 'earbuds', 'wireless', 'electronics'],
    images: [
      'https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=400&h=400&fit=crop',
    ],
    rating: 4.9,
    reviewCount: 1234,
    stock: 200,
    sales: 3456,
    featured: true,
  },
  {
    id: 'prod-t1-2',
    merchantId: 'merchant-tech-1',
    name: 'Smart Watch Series X',
    description: 'Advanced smartwatch with health monitoring features.',
    price: 299.99,
    originalPrice: 399.99,
    discount: 25,
    category: 'technology',
    tags: ['smartwatch', 'wearable', 'fitness', 'electronics'],
    images: [
      'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 890,
    stock: 80,
    sales: 2345,
    featured: true,
  },
  {
    id: 'prod-t1-3',
    merchantId: 'merchant-tech-1',
    name: 'Portable Power Bank 20000mAh',
    description: 'High-capacity power bank with fast charging.',
    price: 49.99,
    originalPrice: 69.99,
    discount: 29,
    category: 'technology',
    tags: ['power-bank', 'charging', 'portable', 'electronics'],
    images: [
      'https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 567,
    stock: 300,
    sales: 1890,
    featured: false,
  },

  // Technology Products - SmartHome Hub
  {
    id: 'prod-t2-1',
    merchantId: 'merchant-tech-2',
    name: 'Smart Security Camera',
    description: '1080p HD security camera with night vision and motion detection.',
    price: 79.99,
    originalPrice: 99.99,
    discount: 20,
    category: 'technology',
    tags: ['smart-home', 'security', 'camera', 'electronics'],
    images: [
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 456,
    stock: 150,
    sales: 890,
    featured: true,
  },
  {
    id: 'prod-t2-2',
    merchantId: 'merchant-tech-2',
    name: 'Smart LED Light Bulbs (4-Pack)',
    description: 'WiFi-enabled color-changing LED bulbs.',
    price: 39.99,
    originalPrice: 54.99,
    discount: 27,
    category: 'technology',
    tags: ['smart-home', 'lighting', 'led', 'electronics'],
    images: [
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    ],
    rating: 4.6,
    reviewCount: 345,
    stock: 250,
    sales: 678,
    featured: false,
  },

  // Technology Products - AudioVision
  {
    id: 'prod-t3-1',
    merchantId: 'merchant-tech-3',
    name: 'Studio Headphones',
    description: 'Professional studio headphones with premium sound quality.',
    price: 199.99,
    originalPrice: 249.99,
    discount: 20,
    category: 'technology',
    tags: ['audio', 'headphones', 'professional', 'electronics'],
    images: [
      'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop',
    ],
    rating: 4.9,
    reviewCount: 678,
    stock: 60,
    sales: 1234,
    featured: true,
  },
  {
    id: 'prod-t3-2',
    merchantId: 'merchant-tech-3',
    name: 'Bluetooth Speaker',
    description: 'Portable waterproof speaker with 360-degree sound.',
    price: 89.99,
    originalPrice: 119.99,
    discount: 25,
    category: 'technology',
    tags: ['audio', 'speaker', 'bluetooth', 'portable'],
    images: [
      'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 456,
    stock: 180,
    sales: 890,
    featured: true,
  },

  // Baby & Kids Products - Little Wonders
  {
    id: 'prod-b1-1',
    merchantId: 'merchant-baby-1',
    name: 'Baby Stroller Premium',
    description: 'Lightweight foldable stroller with all-terrain wheels.',
    price: 249.99,
    originalPrice: 349.99,
    discount: 29,
    category: 'baby',
    tags: ['stroller', 'baby-gear', 'travel'],
    images: [
      'https://images.unsplash.com/photo-1591088398332-8a7791972843?w=400&h=400&fit=crop',
    ],
    rating: 4.9,
    reviewCount: 567,
    stock: 40,
    sales: 890,
    featured: true,
  },
  {
    id: 'prod-b1-2',
    merchantId: 'merchant-baby-1',
    name: 'Organic Baby Blanket Set',
    description: 'Ultra-soft organic cotton blankets (3-pack).',
    price: 44.99,
    originalPrice: 59.99,
    discount: 25,
    category: 'baby',
    tags: ['blanket', 'organic', 'baby-essentials'],
    images: [
      'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 345,
    stock: 200,
    sales: 678,
    featured: true,
  },
  {
    id: 'prod-b1-3',
    merchantId: 'merchant-baby-1',
    name: 'Baby Monitor WiFi',
    description: 'HD video baby monitor with temperature sensor.',
    price: 99.99,
    originalPrice: 129.99,
    discount: 23,
    category: 'baby',
    tags: ['monitor', 'baby-safety', 'electronics'],
    images: [
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 234,
    stock: 80,
    sales: 456,
    featured: false,
  },

  // Baby & Kids Products - BabyEssentials
  {
    id: 'prod-b2-1',
    merchantId: 'merchant-baby-2',
    name: 'Diaper Bag Backpack',
    description: 'Spacious diaper bag with multiple compartments.',
    price: 49.99,
    originalPrice: 69.99,
    discount: 29,
    category: 'baby',
    tags: ['diaper-bag', 'baby-gear', 'travel'],
    images: [
      'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=400&h=400&fit=crop',
    ],
    rating: 4.6,
    reviewCount: 289,
    stock: 150,
    sales: 567,
    featured: true,
  },
  {
    id: 'prod-b2-2',
    merchantId: 'merchant-baby-2',
    name: 'Baby Bottle Set (6-Pack)',
    description: 'Anti-colic baby bottles with natural flow nipples.',
    price: 34.99,
    originalPrice: 44.99,
    discount: 22,
    category: 'baby',
    tags: ['bottles', 'feeding', 'baby-essentials'],
    images: [
      'https://images.unsplash.com/photo-1584839404042-8bc21d240e63?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 456,
    stock: 250,
    sales: 890,
    featured: false,
  },

  // Baby & Kids Products - Kids Paradise
  {
    id: 'prod-b3-1',
    merchantId: 'merchant-baby-3',
    name: 'Educational Building Blocks (100pcs)',
    description: 'Colorful building blocks for creative learning.',
    price: 39.99,
    originalPrice: 54.99,
    discount: 27,
    category: 'baby',
    tags: ['toys', 'educational', 'building-blocks'],
    images: [
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 567,
    stock: 180,
    sales: 1234,
    featured: true,
  },
  {
    id: 'prod-b3-2',
    merchantId: 'merchant-baby-3',
    name: 'Kids Art Supplies Set',
    description: 'Complete art set with crayons, paints, and brushes.',
    price: 29.99,
    originalPrice: 39.99,
    discount: 25,
    category: 'baby',
    tags: ['art', 'creative', 'kids-activities'],
    images: [
      'https://images.unsplash.com/photo-1513542789411-b6a5d4f31634?w=400&h=400&fit=crop',
    ],
    rating: 4.6,
    reviewCount: 234,
    stock: 200,
    sales: 567,
    featured: true,
  },

  // Education Products - LearnSmart
  {
    id: 'prod-e1-1',
    merchantId: 'merchant-edu-1',
    name: 'Online Course: Web Development',
    description: 'Complete web development bootcamp with certificate.',
    price: 89.99,
    originalPrice: 199.99,
    discount: 55,
    category: 'education',
    tags: ['online-course', 'programming', 'web-development'],
    images: [
      'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=400&fit=crop',
    ],
    rating: 4.9,
    reviewCount: 1234,
    stock: 999,
    sales: 4567,
    featured: true,
  },
  {
    id: 'prod-e1-2',
    merchantId: 'merchant-edu-1',
    name: 'Language Learning Software',
    description: 'Interactive software for learning new languages.',
    price: 49.99,
    originalPrice: 79.99,
    discount: 37,
    category: 'education',
    tags: ['software', 'language-learning', 'education'],
    images: [
      'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=400&h=400&fit=crop',
    ],
    rating: 4.7,
    reviewCount: 567,
    stock: 999,
    sales: 1890,
    featured: true,
  },

  // Education Products - BookHaven
  {
    id: 'prod-e2-1',
    merchantId: 'merchant-edu-2',
    name: 'Bestseller Novel Collection (5 Books)',
    description: 'Curated collection of award-winning novels.',
    price: 59.99,
    originalPrice: 89.99,
    discount: 33,
    category: 'education',
    tags: ['books', 'novels', 'reading'],
    images: [
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 890,
    stock: 150,
    sales: 2345,
    featured: true,
  },
  {
    id: 'prod-e2-2',
    merchantId: 'merchant-edu-2',
    name: 'Science Encyclopedia',
    description: 'Comprehensive science encyclopedia for all ages.',
    price: 34.99,
    originalPrice: 49.99,
    discount: 30,
    category: 'education',
    tags: ['books', 'science', 'encyclopedia', 'reference'],
    images: [
      'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=400&h=400&fit=crop',
    ],
    rating: 4.9,
    reviewCount: 567,
    stock: 200,
    sales: 1234,
    featured: false,
  },
  {
    id: 'prod-e2-3',
    merchantId: 'merchant-edu-2',
    name: 'Children Picture Book Set',
    description: 'Illustrated story books for young readers (10 books).',
    price: 44.99,
    originalPrice: 64.99,
    discount: 31,
    category: 'education',
    tags: ['books', 'children', 'picture-books'],
    images: [
      'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=400&fit=crop',
    ],
    rating: 4.8,
    reviewCount: 345,
    stock: 180,
    sales: 890,
    featured: true,
  },

  // Education Products - SchoolSupply Pro
  {
    id: 'prod-e3-1',
    merchantId: 'merchant-edu-3',
    name: 'Premium Notebook Set (5-Pack)',
    description: 'College-ruled notebooks with durable covers.',
    price: 19.99,
    originalPrice: 29.99,
    discount: 33,
    category: 'education',
    tags: ['stationery', 'notebooks', 'school-supplies'],
    images: [
      'https://images.unsplash.com/photo-1531346878377-a5be20888e57?w=400&h=400&fit=crop',
    ],
    rating: 4.5,
    reviewCount: 234,
    stock: 400,
    sales: 890,
    featured: false,
  },
  {
    id: 'prod-e3-2',
    merchantId: 'merchant-edu-3',
    name: 'Scientific Calculator',
    description: 'Advanced scientific calculator for students.',
    price: 24.99,
    originalPrice: 34.99,
    discount: 29,
    category: 'education',
    tags: ['calculator', 'math', 'school-supplies'],
    images: [
      'https://images.unsplash.com/photo-1564466809058-bf4114d55352?w=400&h=400&fit=crop',
    ],
    rating: 4.6,
    reviewCount: 178,
    stock: 200,
    sales: 567,
    featured: true,
  },
];

// Helper functions
export const getMerchantById = (id) => MERCHANTS.find(m => m.id === id);
export const getMerchantBySlug = (slug) => MERCHANTS.find(m => m.slug === slug);
export const getProductById = (id) => PRODUCTS.find(p => p.id === id);
export const getProductsByMerchant = (merchantId) => PRODUCTS.filter(p => p.merchantId === merchantId);
export const getProductsByCategory = (category) => PRODUCTS.filter(p => p.category === category);
export const getMerchantsByCategory = (category) => MERCHANTS.filter(m => m.category === category);
export const getFeaturedProducts = () => PRODUCTS.filter(p => p.featured);
export const getTopSellingProducts = (limit = 10) =>
  [...PRODUCTS].sort((a, b) => b.sales - a.sales).slice(0, limit);

// Calculate commission for an order
// Merchants do NOT earn commission on their own products - only revenue
// Commissions are only earned when a different merchant's products helped drive the conversion
export const calculateCommission = (orderTotal, referralMerchantId, sellingMerchantId) => {
  // Marketplace always gets its cut
  const marketplaceCommission = orderTotal * COMMISSION_RATES.MARKETPLACE;

  if (!referralMerchantId || referralMerchantId === sellingMerchantId) {
    // No referral OR same merchant - seller gets 95%, marketplace gets 5%
    // Merchants don't earn commission on their own products
    return {
      referralCommission: 0,
      sellerAmount: orderTotal * COMMISSION_RATES.SELLER_NO_REFERRAL,
      marketplaceCommission,
      referralMerchantId: null,
      sellingMerchantId,
    };
  }

  // Different merchants - referral merchant earns commission
  // Seller: 85%, Referral: 10%, Marketplace: 5%
  const referralCommission = orderTotal * COMMISSION_RATES.REFERRAL;
  const sellerAmount = orderTotal * COMMISSION_RATES.SELLER_WITH_REFERRAL;

  return {
    referralCommission,
    sellerAmount,
    marketplaceCommission,
    referralMerchantId,
    sellingMerchantId,
  };
};

// Get product recommendations based on category and tags
export const getRecommendations = (productId, limit = 8) => {
  const product = getProductById(productId);
  if (!product) return [];

  // Score products based on matching criteria
  const scoredProducts = PRODUCTS
    .filter(p => p.id !== productId)
    .map(p => {
      let score = 0;

      // Same category: +3 points
      if (p.category === product.category) score += 3;

      // Same merchant: +1 point
      if (p.merchantId === product.merchantId) score += 1;

      // Matching tags: +1 point each
      const matchingTags = p.tags.filter(tag => product.tags.includes(tag));
      score += matchingTags.length;

      // Higher rated products: +1 point for 4.7+
      if (p.rating >= 4.7) score += 1;

      // Featured products: +1 point
      if (p.featured) score += 1;

      return { ...p, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);

  return scoredProducts;
};

// Get cross-category recommendations (for referral commission opportunities)
export const getCrossCategoryRecommendations = (productId, limit = 4) => {
  const product = getProductById(productId);
  if (!product) return [];

  return PRODUCTS
    .filter(p => p.id !== productId && p.category !== product.category)
    .filter(p => p.featured || p.rating >= 4.7)
    .sort((a, b) => b.sales - a.sales)
    .slice(0, limit);
};
